/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { OrderByPipe } from "node_modules/valuchaincommon/shared-components/order-by/order-by.pipe";
import { cloneDeep } from "lodash-es";
import { isHappyBabyFlag } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class StoresService {
  public bulkUploadLabelKey = { label: "", key: "" };
  public selectedBusinessUnit;
  public currentBunitObject;
  public currentBunitDetailedObject;
  public isBackFromDetailed = false;
  public isBulkUpload = false;
  public fromInseason = false;
  public optionTree;
  public productsData = [];
  public productsDataActual = [];
  public filteredInventoryGroupList = [];
  public boardName = "";
  public isHome = false;
  public archiveProductsData = [];
  public filters = [];
  public filtersFinal = [];
  public selectedFilters = [];
  public selectedFiltersFinal = [];
  public selectedCategories = [];
  public selectedCategoriesFinal = [];
  public isFilterReset = false;
  public categoryFilters = [];
  public categoryFiltersFinal = [];
  public dataSource;
  public productOriginalData = [];
  public boardList = [];
  public isTabsTransition = false;
  public dataSourceFinal;
  public autoScroll;
  notifications;
  isHBS = isHappyBabyFlag.flag;
  notificationCount = 0;
  mobileSelectedIndex;
  productsList = [];
  originalProductsList = [];
  list;
  isFiltersRefresh = false;
  refreshAfterRestored = false;
  lastIndex = 0;
  storeRevisedProducts = [];
  globalDiscount = 0;
  originalRevisedProducts = [];
  globalSelect = true;
  selectedProducts = [];
  selectedProductsArchive = [];
  isSelectAll = false;
  productsCount = 0;
  isPartialSelect = false;
  isSelectAllArchive = false;
  isPartialSelectArchive = false;
  category_filter;
  isRefresh = false;
  isFinished = false;
  isEditCompare = false;
  isStartCompare = false;
  selectedBoardMobileBoard;
  detailedBoard;
  selectedGroupMobileCount = 0;
  selectedGroupMobileBoard;
  isAllCasesSelected = false;
  minMSRP = undefined;
  maxMSRP = undefined;
  minWSRP = undefined;
  maxWSRP = undefined;
  includeInStock = false;
  excludeInStock = false;
  isMSRPRangeInvalid = false;
  isWSRPRangeInvalid = false;
  compareProducts = Array(4).fill(0);
  throwResetFlag: BehaviorSubject<boolean> = new BehaviorSubject(false);
  throwHeaderFlag: BehaviorSubject<string> = new BehaviorSubject("");
  throwLoginFlag: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isReloaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
  filterReset: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // public bulkUploadLabelKey = { label: '', key: ''}
  // public selectedBusinessUnit: any;
  productLine = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    sort: "",
    search: "",
    includeInStock: false,
    excludeInStock: false,
  };
  collectionsList = {
    sort: "",
    filter: "",
    search: "",
  };
  boardGroupView = {
    sort: "",
    search: "",
  };
  orderLink = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  styles = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    discountsArray: [],
    sort: "",
    search: "",
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  archive = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    sort: "",
    search: "",
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  catalog = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  seasonInventorySummary = {
    sort: "",
    search: "",
  };
  videoCall = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  dynamicBoard = {
    categories: [],
    grades: [],
    selectedCategories: [],
    selectedGrades: [],
    refreshFilters: [],
    inventoryGroups: [],
    minMSRP: undefined,
    maxMSRP: undefined,
    minWSRP: undefined,
    maxWSRP: undefined,
    includeInStock: false,
    excludeInStock: false,
  };
  updateEditCount = 0;
  previousArrangedProducts = [];
  selectedEditFilters = [];
  productLineInventoryGroups = [];
  consumerSubscribers = {
    selectedTags: [],
    selectedLocations: [],
    selectedAges: [],
    selectedGenders: [],
    appliedTagFilters: "",
    appliedAgeFilters: "",
    appliedGenderFilters: "",
    appliedLocationFilters: "",
    preSelectedTags: [],
    preSelectedLocations: [],
    preSelectedAges: [],
    preSelectedGenders: [],
  };
  consumerMembers = {
    selectedTags: [],
    selectedLocations: [],
    selectedAges: [],
    selectedGenders: [],
    selectedContactTypes: [],
    selectedNewsLetterTypes: [],
    appliedTagFilters: "",
    appliedAgeFilters: "",
    appliedGenderFilters: "",
    appliedLocationFilters: "",
    appliedContactFilters: [],
    appliedNewsLetterFilters: [],
    preSelectedTags: [],
    preSelectedLocations: [],
    preSelectedAges: [],
    preSelectedGenders: [],
    preSelectedContacts: [],
    preSelectedNewsLetterFilters: [],
  };
  consumerCreateGroups = {
    selectedTags: [],
    selectedLocations: [],
    selectedAges: [],
    selectedGenders: [],
    selectedContacts: [],
    selectedNewsLetterTypes: [],
  };
  boardTypeNames = {
    CollectionBoards: "Collection Board",
    CollectionBoard: "Collection Board",
    pdf: "Board Document",
    video: "Board Video",
    image: "Board Image",
    imageAndVideo: "Interactive Image & Video",
    interactiveImage: "Shop the Look",
    "Showroom View": "Showroom View",
    "3D-Tour": "3D Tour",
    "Board Document": "Board Document",
    "Board Image": "Board Image",
    "Board Video": "Board Video",
    "Room Plan": "Room Plan",
  };
  boardTypeList = [
    "Board Document",
    "Board Image",
    "Board Video",
    "Collection Board",
    "Interactive Image & Video",
    "Room Plan",
    "Shop the Look",
    "Showroom View",
    "3D Tour",
  ];
  isInSeasonInventoryHidden = true;
  isCloseOrderLinkCreation = false;
  isReloadMobileProductLine = false;
  constructor(public router: Router) {}

  redirectToBulkUpload(label, key, businessUnit) {
    this.selectedBusinessUnit = businessUnit;
    this.bulkUploadLabelKey.label = label;
    this.bulkUploadLabelKey.key = key;
    this.isBulkUpload = true;
    localStorage.setItem("bulkUpload", key);
    this.router.navigateByUrl("/bulkupload");
  }
  resetFiltersData() {
    this.isTabsTransition = true;
    this.categoryFiltersFinal = [];
    this.selectedCategoriesFinal = [];
    this.filteredInventoryGroupList = [];
    this.selectedCategories = [];
    this.selectedFilters = [];
    this.optionTree = [];
    this.productsData = [];
    this.includeInStock = false;
    this.excludeInStock = false;
  }

  resetData() {
    this.productLine = {
      categories: [],
      grades: [],
      selectedCategories: [],
      selectedGrades: [],
      refreshFilters: [],
      inventoryGroups: [],
      minMSRP: undefined,
      maxMSRP: undefined,
      minWSRP: undefined,
      maxWSRP: undefined,
      sort: "",
      search: "",
      includeInStock: false,
      excludeInStock: false,
    };
    this.styles = {
      categories: [],
      grades: [],
      selectedCategories: [],
      selectedGrades: [],
      refreshFilters: [],
      inventoryGroups: [],
      discountsArray: [],
      sort: "",
      search: "",
      minMSRP: undefined,
      maxMSRP: undefined,
      minWSRP: undefined,
      maxWSRP: undefined,
      includeInStock: false,
      excludeInStock: false,
    };
    this.archive = {
      categories: [],
      grades: [],
      selectedCategories: [],
      selectedGrades: [],
      refreshFilters: [],
      inventoryGroups: [],
      sort: "",
      search: "",
      minMSRP: undefined,
      maxMSRP: undefined,
      minWSRP: undefined,
      maxWSRP: undefined,
      includeInStock: false,
      excludeInStock: false,
    };
    this.catalog = {
      categories: [],
      grades: [],
      selectedCategories: [],
      selectedGrades: [],
      refreshFilters: [],
      inventoryGroups: [],
      minMSRP: undefined,
      maxMSRP: undefined,
      minWSRP: undefined,
      maxWSRP: undefined,
      includeInStock: false,
      excludeInStock: false,
    };
    this.seasonInventorySummary = {
      sort: "",
      search: "",
    };
    this.collectionsList = {
      sort: "",
      filter: "",
      search: "",
    };
    this.minMSRP = undefined;
    this.maxMSRP = undefined;
    this.minWSRP = undefined;
    this.maxWSRP = undefined;
    this.isMSRPRangeInvalid = false;
    this.isWSRPRangeInvalid = false;
    this.optionTree = undefined;
    this.includeInStock = false;
    this.excludeInStock = false;
  }

  resetConsumerMemberData() {
    this.consumerMembers = {
      selectedTags: [],
      selectedLocations: [],
      selectedAges: [],
      selectedGenders: [],
      selectedContactTypes: [],
      selectedNewsLetterTypes: [],
      appliedTagFilters: "",
      appliedAgeFilters: "",
      appliedGenderFilters: "",
      appliedLocationFilters: "",
      appliedContactFilters: [],
      appliedNewsLetterFilters: [],
      preSelectedTags: [],
      preSelectedLocations: [],
      preSelectedAges: [],
      preSelectedGenders: [],
      preSelectedContacts: [],
      preSelectedNewsLetterFilters: [],
    };
  }
  checkSubString(mainString, subString) {
    return mainString.toLowerCase().split(" ").join("").includes(subString)
      ? true
      : false;
  }
  checkTryonType(mainString) {
    let type;
    let productName = mainString.toLowerCase().split(" ").join("");
    if (productName.includes("earrings")) {
      type = "earrings";
    } else if (productName.includes("necklace")) {
      type = "necklace";
    } else if (productName.includes("ring")) {
      type = "ring";
    } else if (productName.includes("bracelet")) {
      type = "bracelet";
    } else if (productName.includes("glasses")) {
      type = "glasses";
    } else if (productName.includes("lipstick")) {
      type = "lipstick";
    } else if (productName.includes("blush")) {
      type = "blush";
    } else if (productName.includes("foundation")) {
      type = "foundation";
    }
    return type;
  }
  resetProductLineData() {
    this.isFilterReset = true;
    this.selectedCategories = [];
    this.selectedFilters = [];
    this.productLine.selectedCategories = [];
    this.productLine.selectedGrades = [];
    this.filters = [];
    this.dataSource = [];
    this.categoryFilters = [];
    this.productLine.categories = [];
    this.productLine.grades = [];
    this.productLine.refreshFilters = [];
    this.productLine.inventoryGroups = [];
    this.dataSource = [];
    this.optionTree = [];
    this.productLine.minMSRP = undefined;
    this.productLine.maxMSRP = undefined;
    this.productLine.minWSRP = undefined;
    this.productLine.maxWSRP = undefined;
    this.productLine.includeInStock = false;
    this.productLine.excludeInStock = false;
    // this.productLine.sort = "";
    this.productLine.search = "";
    this.productsData = [];
    this.filteredInventoryGroupList = [];
    this.includeInStock = false;
    this.excludeInStock = false;
  }
  matchCategory(inventory, category_filter, filters?, isStl?, isFilter?) {
    if (category_filter.length) {
      const index = category_filter.findIndex(
        (category) => category === inventory.inventoryGroup.productCategory
      );
      if (filters && filters.length) {
        let filterIndex = true;
        let names = [];
        let matchedValue = false;
        filters.forEach((each) => {
          if (names.findIndex((name) => name === each.name) === -1) {
            names.push(each.name);
          }
        });
        names.forEach((each) => {
          const newFilters = filters.filter(
            (eachFilter) => eachFilter.name === each
          );
          let innerValue = false;
          inventory.inventoryGroup.gradeDefinition.forEach((eachGrade) => {
            if (
              newFilters.findIndex(
                (each) =>
                  (each.name === "Color" || each.name === "Colour"
                    ? eachGrade.attributeKey === "Color" ||
                      eachGrade.attributeKey === "Colour"
                    : eachGrade.attributeKey === each.name) &&
                  each.value !== undefined &&
                  (each.value === eachGrade.attributeValue ||
                    (each.name === "Size" &&
                      eachGrade.attributeValue
                        .split(",")
                        .map((ele) => ele.trim())
                        .includes(each.value)))
              ) > -1
            ) {
              innerValue = innerValue || true;
              matchedValue = true;
            }
          });
          if (isStl) {
            filterIndex = matchedValue;
          } else {
            filterIndex = filterIndex && innerValue;
          }
        });
        return filterIndex && index > -1;
      } else {
        if (isFilter) {
          return -1;
        } else {
          return index > -1 ? true : false;
        }
      }
    } else {
      if (filters && filters.length) {
        let filterIndex = true;
        let names = [];
        filters.forEach((each) => {
          if (names.findIndex((name) => name === each.name) === -1) {
            names.push(each.name);
          }
        });
        names.forEach((each) => {
          const newFilters = filters.filter(
            (eachFilter) => eachFilter.name === each
          );
          let innerValue = false;
          inventory.inventoryGroup.gradeDefinition.forEach((eachGrade) => {
            if (
              newFilters.findIndex(
                (each) =>
                  (each.name === "Color" || each.name === "Colour"
                    ? eachGrade.attributeKey === "Color" ||
                      eachGrade.attributeKey === "Colour"
                    : eachGrade.attributeKey === each.name) &&
                  each.value !== undefined &&
                  this.matchGradeFilters(each, eachGrade)
              ) > -1
            ) {
              innerValue = innerValue || true;
            }
          });
          filterIndex = filterIndex && innerValue;
        });
        return filterIndex;
      } else {
        if (isStl && isFilter) {
          return false;
        } else {
          return true;
        }
      }
    }
  }

  matchGradeFilters(each, eachGrade) {
    if (this.matchColorAttribute(eachGrade.attributeKey)) {
      return (
        this.matchColorAttribute(each.name) &&
        each.value !== undefined &&
        each.value === eachGrade.attributeValue
      );
    } else {
      return (
        eachGrade.attributeKey === each.name &&
        each.value !== undefined &&
        (each.value === eachGrade.attributeValue ||
          (each.name === "Size" &&
            eachGrade.attributeValue
              .split(",")
              .map((ele) => ele.trim())
              .includes(each.value)))
      );
    }
  }

  transformColours(value: any) {
    function compareHelper(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }
    function compare(a, b) {
      const stageFirst = a.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Colour"
      );
      const stageSecond = b.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Colour"
      );
      if (
        stageFirst[0] &&
        stageSecond[0] &&
        stageFirst[0].attributeValue &&
        stageSecond[0].attributeValue
      ) {
        let first = stageFirst[0].attributeValue;
        let second = stageSecond[0].attributeValue;

        return compareHelper(first?.toLowerCase(), second?.toLowerCase());
      } else {
        if (stageFirst[0] && !stageSecond[0]) {
          return -1;
        } else {
          return 1;
        }
      }
    }
    return value.sort(compare);
  }
  preprocessData(productsData, id) {
    let tempData = [];
    productsData.forEach((prod) => {
      prod = JSON.parse(JSON.stringify(prod));
      prod.inventoryGroup.inventoryGroupSets.forEach((element) => {
        if (element.inventoryGroupSet === id) {
          prod["indexValue"] = element.position[0];
        }
      });
      if (prod.indexValue === undefined) {
        prod["indexValue"] = productsData.length;
      }
      tempData.push(prod);
    });
    return tempData;
  }
  sortByName() {
    OrderByPipe.prototype.transform(this.productOriginalData, ["productName"]);
  }
  sortForReverse(value, field, nameSort?) {
    console.log(value.length);
    let finalList = [];
    let currPrice = value[0][field];
    let windowStart = 0;
    let i;
    for (i = 1; i < value.length; i++) {
      if (currPrice !== value[i][field]) {
        let tempList = value.slice(windowStart, i);
        OrderByPipe.prototype.transform(tempList, ["colour"]);
        if (!nameSort) {
          OrderByPipe.prototype.transform(tempList, ["productName"]);
        } else {
          OrderByPipe.prototype.transform(tempList, nameSort);
        }
        for (let j = 0; j < tempList.length; j++) {
          finalList.push(tempList[j]);
        }
        windowStart = i;
        currPrice = value[i][field];
      }
    }
    let tempList = value.slice(windowStart, i);
    tempList = this.transformColours(tempList);
    if (!nameSort) {
      OrderByPipe.prototype.transform(tempList, ["productName"]);
    } else {
      OrderByPipe.prototype.transform(tempList, nameSort);
    }
    for (let j = 0; j < tempList.length; j++) {
      finalList.push(tempList[j]);
    }
    console.log(finalList.length);
    return finalList;
  }
  transformDiscount(value: any) {
    function compareHelper(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }
    function compare(a, b) {
      const stageFirst = a.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Discount"
      );
      const stageSecond = b.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Discount"
      );
      if (
        stageFirst[0] &&
        stageSecond[0] &&
        stageFirst[0].attributeValue &&
        stageSecond[0].attributeValue
      ) {
        let first = stageFirst[0].attributeValue;
        let second = stageSecond[0].attributeValue;

        return compareHelper(first, second);
      } else {
        if (stageFirst[0] && !stageSecond[0]) {
          return -1;
        } else {
          return 1;
        }
      }
    }
    return value.sort(compare);
  }
  transformStyleCode(value: any) {
    function compareHelper(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }
    function compare(a, b) {
      const stageFirst = a.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Style Code"
      );
      const stageSecond = b.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Style Code"
      );
      if (
        stageFirst[0] &&
        stageSecond[0] &&
        stageFirst[0].attributeValue &&
        stageSecond[0].attributeValue
      ) {
        let first = stageFirst[0].attributeValue;
        let second = stageSecond[0].attributeValue;

        return compareHelper(first, second);
      } else {
        if (stageFirst[0] && !stageSecond[0]) {
          return -1;
        } else {
          return 1;
        }
      }
    }
    return value.sort(compare);
  }

  transformGradeAttribute(value: any, type) {
    function compareHelper(a, b) {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }
    function compare(a, b) {
      const stageFirst = a.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === type
      );
      const stageSecond = b.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === type
      );
      if (
        stageFirst[0] &&
        stageSecond[0] &&
        stageFirst[0].attributeValue &&
        stageSecond[0].attributeValue
      ) {
        let first = stageFirst[0].attributeValue;
        let second = stageSecond[0].attributeValue;

        return compareHelper(first, second);
      } else {
        if (stageFirst[0] && !stageSecond[0]) {
          return -1;
        } else {
          return 1;
        }
      }
    }
    return value.sort(compare);
  }

  transformSeasons(value: any) {
    function compareHelper(a, b) {
      if (a < b) {
        return 1;
      }
      if (a > b) {
        return -1;
      }
      return 0;
    }
    function compare(a, b) {
      const stageFirst = a.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Seasons"
      );
      const stageSecond = b.inventoryGroup.gradeDefinition.filter(
        (attribute) => attribute.attributeKey === "Seasons"
      );
      if (
        stageFirst[0] &&
        stageSecond[0] &&
        stageFirst[0].attributeValue &&
        stageSecond[0].attributeValue
      ) {
        let first = stageFirst[0].attributeValue.split(" ");
        let second = stageSecond[0].attributeValue.split(" ");
        let firstString = "";
        let secondString = "";
        if (first.length === 1 && second.length !== 1) {
          return 1;
        }
        if (first.length !== 1 && second.length === 1) {
          return -1;
        }
        if (second.length === 1 && first.length === 1) {
          return compareHelper(first, second);
        }
        if (
          /\d{4}$/.test(first[first.length - 1]) &&
          /\d{4}$/.test(second[second.length - 1])
        ) {
          firstString += first[first.length - 1];
          secondString += second[second.length - 1];
          if (first[first.length - 2] === "HOL") {
            first[first.length - 2] = "3";
          }
          if (second[second.length - 2] === "HOL") {
            second[second.length - 2] = "3";
          }
          if (first[0] === "FALL") {
            firstString += "2";
          } else {
            firstString += "1";
          }
          if (second[0] === "FALL") {
            secondString += "2";
          } else {
            secondString += "1";
          }
          if (
            /\d{1}$/.test(first[first.length - 2]) &&
            /\d{1}$/.test(second[second.length - 2])
          ) {
            firstString += first[first.length - 2];
            secondString += second[second.length - 2];
            return compareHelper(firstString, secondString);
          }
          return compareHelper(firstString, secondString);
        }
        return compareHelper(first, second);
      } else {
        if (stageFirst[0] && !stageSecond[0]) {
          return -1;
        } else {
          return 1;
        }
      }
    }
    return value.sort(compare);
  }
  checkAvailability(list, include, exclude) {
    return list.filter(
      (each) =>
        (include && each.inventoryGroup.numberOfUnits) ||
        (exclude && !each.inventoryGroup.numberOfUnits)
    );
  }

  getDealerOrConfiguratorPrice(each) {
    return (
      (each.inventoryGroup.price.dealerPrice.value
        ? each.inventoryGroup.price.dealerPrice.value
        : each.inventoryGroup.price.MRP.value) +
      (each.inventoryGroup?.price?.configuratorPrice || 0)
    );
  }

  filterByPrice(data, minMSRP, maxMSRP, minWSRP, maxWSRP) {
    let tempList = cloneDeep(data);

    if (minMSRP && maxMSRP) {
      tempList = tempList.filter(
        (each) =>
          this.getDealerOrConfiguratorPrice(each) >= minMSRP &&
          this.getDealerOrConfiguratorPrice(each) <= maxMSRP
      );
    } else if (minMSRP) {
      tempList = tempList.filter(
        (each) => this.getDealerOrConfiguratorPrice(each) >= minMSRP
      );
    } else if (maxMSRP) {
      tempList = tempList.filter(
        (each) => this.getDealerOrConfiguratorPrice(each) <= maxMSRP
      );
    }

    if (minWSRP && maxWSRP) {
      tempList = tempList.filter(
        (each) =>
          this.getDealerOrConfiguratorPrice(each) >= minWSRP &&
          this.getDealerOrConfiguratorPrice(each) <= maxWSRP
      );
    } else if (minWSRP) {
      tempList = tempList.filter(
        (each) => this.getDealerOrConfiguratorPrice(each) >= minWSRP
      );
    } else if (maxWSRP) {
      tempList = tempList.filter(
        (each) => this.getDealerOrConfiguratorPrice(each) <= maxWSRP
      );
    }
    return tempList;
  }

  isPriceFilter(type?) {
    return (
      (type &&
        (this[type].minMSRP ||
          this[type].maxMSRP ||
          this[type].minWSRP ||
          this[type].maxWSRP) &&
        ((!this[type].minMSRP && !this[type].maxMSRP
          ? false
          : !this.isMSRPRangeInvalid) ||
          (!this[type].minWSRP && !this[type].maxWSRP
            ? false
            : !this.isWSRPRangeInvalid))) ||
      ((this.minMSRP || this.maxMSRP || this.minWSRP || this.maxWSRP) &&
        ((!this.minMSRP && !this.maxMSRP ? false : !this.isMSRPRangeInvalid) ||
          (!this.minWSRP && !this.maxWSRP ? false : !this.isWSRPRangeInvalid)))
    );
  }
  setProductsList(data) {
    this.productsList = data.map((each) => {
      return {
        _id: each.inventoryGroup._id,
        gradeDefinition: each.inventoryGroup.gradeDefinition,
        name: each.inventoryGroup.productCategoryName,
        subCategory: each.inventoryGroup.productSubCategoryName,
        category: each.inventoryGroup.productMainCategoryName,
        brandName: each.inventoryGroup.productBrandName,
        brandVariety: each.inventoryGroup.productBrandVarietyName,
      };
    });
    this.originalProductsList = this.productsList;
    this.mapObject();
  }
  mapObject() {
    this.list = [];
    this.productsList.filter((each) => {
      this.list[each._id] = {
        name: each.name,
      };
    });
  }
  filterBoardList(response) {
    return response.filter(
      (element) =>
        element._id &&
        element.boardData &&
        (element.count > 0 ||
          (element.boardData.length > 0 &&
            (element.boardData[0].type === "video" ||
              element.boardData[0].type === "image" ||
              element.boardData[0].type === "pdf")))
    );
  }
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
        ]
      : null;
  }

  redirectToCustomerUrl(check?) {
    let companyLiveUrl = "";
    let config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : JSON.parse(localStorage.getItem("companyConfig"));
    if (config && config.whiteshop && config.whiteshop.clickToCall) {
      companyLiveUrl = config.whiteshop.clickToCall.originUrl;
    }
    if (companyLiveUrl && !localStorage.getItem("retailerToken")) {
      if (check) {
        return true;
      } else {
        window.open(companyLiveUrl, "_self");
      }
    } else {
      return false;
    }
  }

  matchColorAttribute(object) {
    if (object.toLowerCase() === "colour" || object.toLowerCase() === "color") {
      return true;
    } else {
      return false;
    }
  }
}
